export default __webpack_public_path__ + "static/media/redarrow-icon.6279bb83.svg";